import { CardMedia } from "@material-ui/core";
import { memo } from "react";

import { FileRemoveAction } from "../../types";
import { DeleteIcon } from "../DeleteIcon";

import styles from "./Image.module.scss";

type ImageProps = {
  readonly isReadOnly: boolean;
  readonly onFileRemove: FileRemoveAction;
  readonly src: string;
};

export const Image = memo<ImageProps>(({ isReadOnly, onFileRemove, src }) => (
  <>
    {!isReadOnly && <DeleteIcon onClick={onFileRemove} />}
    <CardMedia
      className={styles.wrapper}
      component="div"
      image={src}
      role="img"
      aria-label="image"
    />
  </>
));
